import { Component } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import Swal from 'sweetalert2';
import { IVaccinationDetailed } from '../../../../../../interfaces/Vaccination/IVaccinationDetailed';
import { VaccinationService } from '../../../../../../services/vaccination.service';
import { VaccinationAddEditComponent } from './vaccination-add-edit/vaccination-add-edit.component';
import { AllergiesExpandComponent } from '../../alerts-section/allergies/allergies-expand/allergies-expand.component';
import { VaccinationExpandComponent } from './vaccination-expand/vaccination-expand.component';
import { TranslateService } from '@ngx-translate/core';
import { COLORS } from 'src/styles/colors';
import { SwalToastService } from 'src/app/services/swal.service';
import { PermissionService } from 'src/app/services/permission.service';

@Component({
    selector: 'app-vaccination',
    templateUrl: './vaccination.component.html',
    styleUrls: ['./vaccination.component.css'],
    standalone: false
})
export class VaccinationComponent {
  protected readonly AllergiesExpandComponent = AllergiesExpandComponent;
  public addComp = VaccinationAddEditComponent;
  public expandComp = VaccinationExpandComponent;

  private destroy$ = new Subject<void>();

  vaccinations?: IVaccinationDetailed[];
  isLoading: boolean = false;

  constructor(
    private readonly vaccinationService: VaccinationService,
    private readonly translate: TranslateService,
    private readonly swalToastService: SwalToastService,
    private readonly permissionService: PermissionService
  ) {}

  ngOnInit() {
    this.vaccinationService.vaccinationLoadingSub
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: boolean) => {
        this.isLoading = data;
      });

    this.vaccinationService.vaccinationDataSub
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: IVaccinationDetailed[]) => {
        this.vaccinations = data;
      });

    this.vaccinationService.getData();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  hasPermission(permission: string[]): boolean {
    return this.permissionService.can(permission);
  }

  openModalFun(item?: IVaccinationDetailed) {
    this.vaccinationService.vaccinationModalSub.next(true);
    this.vaccinationService.vaccinationEditSub.next(item);
  }

  deleteFun(vaccinationId: number) {
    Swal.fire({
      text: `${this.translate.instant(
        'deletePlaceholder5'
      )} ${this.translate.instant('Vaccination')}?`,
      showDenyButton: false,
      showCancelButton: true,
      cancelButtonText: `${this.translate.instant('Cancel')}`,
      confirmButtonText: `${this.translate.instant('Ok')}`,
    }).then((result) => {
      if (result.isConfirmed) {
        this.vaccinationService
          .deleteVaccination(vaccinationId.toString())
          .subscribe({
            next: (d) => {
              this.swalToastService.toastSuccess(
                'Vaccination deleted successfully'
              );
              this.vaccinationService.deleteVaccinationFromTable(
                vaccinationId.toString()
              );
            },
            error: (err) => {
              this.swalToastService.toastError('Unable to delete vaccination');
            },
          });
      } else if (result.isDenied) {
        Swal.fire(
          `${this.translate.instant('Vaccination is not deleted')}`,
          '',
          'info'
        );
      }
    });
  }
}
